// This file is auto-generated
/* eslint-disable */
import deAT from './universalat/de-AT.json';
const messages = { 'de-AT': deAT };
export default messages;